import React, { useEffect, useState } from 'react'
import Validator from 'validator'
import { Form, Row, Col, Container } from 'react-bootstrap'
import { BackButton, handleNext } from '../Button/button'
import Chart from '../Chart/Chart'
import { apiUrl } from '../../constants'
import { ContinueButton } from '../Button/button'
import { TotalEmission, getTenantData, getLandlordData, CalculateShare } from '../Calculation/Calculation'
import axios from 'axios'

import IconFlussiggas from '../../assets/icons/IconFlussiggas.svg'
import IconErdgas from '../../assets/icons/IconErdgas.svg'
import IconHeizol from '../../assets/icons/IconHeizol.svg'
import IconFernwarme from '../../assets/icons/IconFernwarme.svg'
import IconHouse from '../../assets/icons/IconHouse.svg'
import IconCloud from '../../assets/icons/IconCloud.svg'
import ImageEmail from '../../assets/images/ImageEmail.png'
import IconEmail from '../../assets/images/EmailRedCircle.svg'
import Note from '../../assets/images/note.svg'
import techemLogoShadow from '../../assets/icons/Techem-Logo-Shadow.png'
import ImageFinalTwo from '../../assets/images/ImageFinalTwo.jpg'
import IconRight from '../../assets/icons/IconRight.svg'
import ImageFinalThree from '../../assets/images/ImageFinalThree.jpg'
import ImagePdfThreeOne from '../../assets/images/pdfThreeOne.png'

import { useCurrentContext } from '../Context/Context'

const FourthStep = () => {
  const { currentSelected, canContinue, setCanContinue, Consumption, TotalArea, setEmail, fetchedData } = useCurrentContext();
  const tenantData = getTenantData(currentSelected, Consumption, fetchedData);
  const landlordData = getLandlordData(tenantData, currentSelected, Consumption, TotalArea, fetchedData);
  const CalculateYearlyCost = () => {
    const sum = landlordData.reduce((partial, current) => {
      return parseFloat(partial) + parseFloat(current)
    }, [0])
    return parseFloat(sum).toFixed(2)
  };

  let selectedIcon
  if (currentSelected.val === 1) {
    selectedIcon = IconFlussiggas
  } else if (currentSelected.val === 2) {
    selectedIcon = IconErdgas
  } else if (currentSelected.val === 3) {
    selectedIcon = IconHeizol
  } else if (currentSelected.val === 4) {
    selectedIcon = IconFernwarme
  }

  const userData = {
    "FuelType": currentSelected.name,
    "ConsumptionUnit": Consumption.Unit,
    "ConsumptionValue": Consumption.Value,
    "TotalArea": TotalArea
  }

  useEffect(() => {
    const dataUploadUrl = apiUrl() + '/api/userData'
    console.log(dataUploadUrl)
    axios.post(dataUploadUrl, userData)
      .then(response => {
        console.log(response);
      });
  }, []);
  const [ValidEmail, setValidEmail] = useState(false)
  const [Consent, setConsent] = useState(false)

  const handleEmailChange = (event) => {
    if (Validator.isEmail(event.target.value)) {
      setEmail(event.target.value)
      setValidEmail(true)
    } else {
      setValidEmail(false)
    }

  }

  const handleConsentChange = (event) => {
    if (event.target.checked) {
      setConsent(true)
    } else {
      setConsent(false)
    }
  }

  const handleSubmit = e => {
    e.preventDefault();
    if (canContinue) {
      const triggerClick = handleNext();
      triggerClick();
    }
  };

  useEffect(() => {
    if (ValidEmail && Consent) {
      setCanContinue(true)
    } else {
      setCanContinue(false)
    }
  }, [ValidEmail, Consent])

  return (
    <>
      <Container>
        <Row>
          <Col lg={6}>
            <Row>
              <BackButton />
              <h3 className='col-11 stepper-text text-center'>
                Ihre kostenlose CO<sub>2</sub>-Kostenprognose <br /> ist nur einen Klick entfernt!
              </h3>
            </Row>
            <p className='mt-5 mb-5'>
              Geben Sie einfach Ihre E-Mail-Adresse an und erhalten
              Sie von uns gebührenfrei Ihre individuelle Prognose sowie wertvolle Energiespartipps!
            </p>
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="formInput" className='col-md-8 d-flex flex-column ms-auto me-auto'>
                <Form.Label>E-Mail</Form.Label>
                <Form.Control type="email"
                  placeholder="Bitte hier eingeben" onChange={handleEmailChange} className='mb-5' autoComplete='off' />
              </Form.Group>
              <Form.Group className="mb-3 container" controlId="formBasicCheckbox">
                <Row className='mb-3'>
                  <Col xs={2} sm={1} className='d-flex justify-content-center'>
                    <Form.Check className='consent-check' type="checkbox" onChange={handleConsentChange} />
                  </Col>
                  <Col xs={10} sm={11}>
                    <Form.Label className='consent-text'>Mit dem Absenden dieses Formulars willige ich ein, dass die Techem GmbH und die mit ihr verbundenen Gesellschaften
                      (Techem Energy Services GmbH, Techem Solutions GmbH, Techem X GmbH,
                      bautec Energiemanagment GmbH) die von mir oben eingetragenen Daten für werbliche Ansprachen per E-Mail und/oder der Auswertung zu Marketingzwecken
                      verarbeitet.
                      <br />
                      Diese Einwilligung erfolgt freiwillig und ist mit Wirkung für die Zukunft jederzeit widerrufbar.
                      Einzelheiten zum Datenschutz bei der Techem GmbH entnehmen Sie bitte dem <a href='https://www.techem.com/de/de/datenschutzhinweis'>Datenschutzhinweis</a>.
                    </Form.Label>
                  </Col>
                </Row>
                <div className='col-md-8 d-flex flex-column ms-auto me-auto'>
                  <ContinueButton></ContinueButton>
                </div>
              </Form.Group>
            </Form>
          </Col>
          <Col lg={6} className='ps-4'>
            <div className='email-img-content'>
              <img className='icon-email' src={IconEmail} alt='email-icon'></img>
              <img className='image-email' src={ImageEmail} alt='email-img'></img>
            </div>
          </Col>
        </Row>
      </Container>
      <div id='pdf-section'>
        <div className='page-2'>
          <div className='page-body'>
            <h4 className='univers-normal mb-3 red-text' style={{ fontSize: '36px' }}>Techem CO<sub>2</sub>-Abgabe-Prognose</h4>

            <div className='univers-normal light-grey-text mb-3'>Ihre individuelle Kostenprognose zur CO<sub>2</sub>-Abgabe</div>
            <div className='univers-bold'>Erhalten Sie einen schnellen
              Überblick über die zu erwartende CO<sub>2</sub>-Abgabe individuell für Ihre Liegenschaft berechnet.
              Als kleines Plus haben wir Ihnen zudem die aktuelle Rechtslage zur CO<sub>2</sub>-Umlage
              zusammengefasst und zeigen Ihnen, mit welchen einfachen Maßnahmen
              Sie und Ihre Mieterinnen und Mieter Energie und somit Emissionen sparen können!
            </div>
            <div id='chart-section' className='mt-3'>
              <Row className={`mb-3 d-flex`}>
                <Col xs={4} className='ps-0 pe-3'>
                  <div className='p-3 d-flex justify-content-between align-items-end'
                    style={{ minHeight: '158px' }}>
                    <div className='d-flex flex-column align-items-center'>
                      <div className='choice-item'>
                        <img src={selectedIcon} alt='item-icon' />
                        <div className='choice-text'>{currentSelected.name}</div>
                      </div>
                      <div className='univers-bold'>{parseFloat(Consumption.Value).toLocaleString('de-DE')} {Consumption.Unit}</div>
                    </div>
                    <div className='d-flex flex-column align-items-center'>
                      <div className='choice-item'>
                        <img src={IconHouse} alt='house-icon' />
                        <div className='choice-text'>Wohnfläche</div>
                      </div>
                      <div className='univers-bold'>{TotalArea} m<sup>2</sup></div>
                    </div>
                  </div>
                </Col>
                <Col xs={3} className='p-0'>
                  <div className='p-3 d-flex flex-column justify-content-end align-items-center blue-border-dashed'
                    style={{ minHeight: '158px' }}>
                    <div className='choice-item'>
                      <img src={IconCloud} alt='house-icon' />
                      <div className='choice-text text-center'>CO<sub>2</sub>-Emission (10 Jahre)</div>
                    </div>
                    <div className='univers-bold d-flex align-items-end'><div className='d-inline'>{parseFloat(((TotalEmission(currentSelected, Consumption, fetchedData) / 1000) * 10).toFixed(2)).toLocaleString('de-DE')} t</div>
                    </div>
                  </div>
                </Col>
                <Col xs={5} className='ps-3 pe-0 d-flex'>
                  <div className='p-3 d-flex blue-border w-100'
                    style={{ minHeight: '158px' }}>
                    <div className='d-flex flex-column w-100 justify-content-end'>
                      <div className='stepper-text fs-40 text-end w-100'>{parseFloat(CalculateYearlyCost()).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</div>
                      <div className='d-flex justify-content-between'>
                        <div>
                          <div className='d-inline univers-bold'>Gesamtkosten</div></div>
                        <div style={{ fontSize: "13px" }}>inkl. MwSt. </div>
                      </div>
                      <div>(10 Jahre)</div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className={'mb-3'}>
                <Row className='mb-3'>
                  <Col xs={5}>
                    <div className='d-flex flex-column'>
                      <div className='univers-bold fs-22 pe-1'>Techem CO<sub>2</sub>-Kostenprognose:</div>
                      <div>Ihr Anteil beträgt voraussichtlich <span className='d-inline-block'>{parseFloat(CalculateShare(currentSelected, Consumption, TotalArea, 1, fetchedData)).toLocaleString('de-DE')} %
                      </span></div>
                    </div>
                  </Col>
                  <Col xs={7}>
                    <Row className='d-flex'>
                      <Col>
                        <Row className='d-flex justify-content-center align-items-center'>
                          <Col xs={1} className='me-3'><span className='dot tenant-dot'></span></Col>
                          <Col xs={3} className='ps-0'><span className='black-text'>Mietende</span></Col>
                        </Row>
                      </Col>
                      <Col className='tenant-text d-flex'>
                        <div>
                          {parseFloat(100 - (CalculateShare(currentSelected, Consumption, TotalArea, 1, fetchedData))).toLocaleString('de-DE')} % Anteil an der CO<sub>2</sub>-Abgabe
                        </div>
                      </Col>

                    </Row>
                    <Row className='d-flex'>
                      <Col>
                        <Row className='d-flex justify-content-center align-items-center'>
                          <Col xs={1} className='me-3'><span className='dot landlord-dot'></span></Col>
                          <Col xs={3} className='ps-0'><span className='univers-bold black-text'>Vermietende</span></Col>
                        </Row>
                      </Col>
                      <Col className='landlord-text d-flex'>
                        <div>
                          {parseFloat(CalculateShare(currentSelected, Consumption, TotalArea, 1, fetchedData)).toLocaleString('de-DE')} % Anteil an der CO<sub>2</sub>-Abgabe
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <div className='d-flex justify-content-lg-center' style={{ "overflowX": "auto" }}>
                  <div id='bar-canvas' style={{ "postion": "relative", "minWidth": "800px" }}>
                    <Chart></Chart>
                  </div>
                </div>
              </Row>
            </div>
            <div className='mt-5 mb-5 univers-normal'>Dieser Wert ergibt sich aus der Energiebilanz Ihres Gebäudes.
              Je besser diese ist, desto niedriger ist Ihr voraussichtlicher Anteil an den CO<sub>2</sub>-Kosten als Vermieterin oder Vermieter.
              Eine Verabschiedung des Gesetzes steht allerdings noch aus, weshalb es sich um eine unverbindliche Prognose handelt.
              Besuchen Sie gerne weiterhin unseren
              <a className='ms-1 red-text' href='https://www.techem.com/de/de/digital-services/co2-kosten-rechner?CID=referrer:organic:co2rechner_pdf:link:co2rechner:lp-rechner:co2:targeting:nr:22092022'
                target='_blank' rel='noopener noreferrer'>
                CO<sub>2</sub>-Rechner
              </a>,
              um über Updates informiert zu werden oder diesen erneut zu nutzen.
            </div>

            <h4 className="univers-normal mb-3 red-text" style={{ fontSize: '25px' }}>Die Rechtslage kurz erklärt</h4>
            <Row className='grey-background ps-5 pe-5 pt-3 pb-3 mb-5 univers-normal'>
              <Col xs={1}><img src={Note} alt='pdf-img' style={{ width: "25px", marginLeft: "40px" }}></img></Col>
              <Col xs={10} className='ms-2'>
                <div>Anfang April hat sich die Bundesregierung auf die Neuregelung zur Verteilung der
                  CO<sub>2</sub>-Bepreisung zwischen Mietenden und Vermietenden geeinigt.
                  Damit nimmt die Regierung nun auch Vermietende mehr in die Pflicht.
                  Sie sollen bei den Heizkosten und der Warmwasseraufbereitung ab 2023 anteilig
                  am CO<sub>2</sub>-Preis beteiligt werden - abhängig von der Klimafreundlichkeit des Gebäudes.
                  Dafür ist ein Zehn-Stufenmodell vorgesehen: Bei Wohnungen mit einer besonders schlechten
                  Energiebilanz übernehmen Vermietende 95 % und Mietende 5 % der CO<sub>2</sub>-Kosten.
                  In den weiteren Stufen nimmt der Anteil für Vermietende ab.

                </div>
              </Col>
            </Row>
          </div>
          <div className='page-footer'>
            <Row className='position-relative mt-3 mb-5 techem-footer'>
              <div style={{ "backgroundColor": "red", "width": "100%", "height": "10px" }}></div>
              <img className='pdf-front-img' src={techemLogoShadow} alt='pdf-img' style={{ width: '220px' }}></img>
            </Row>
          </div>
        </div>
        <div className='page-3'>
          <div className='page-body'>
            <h4 className="univers-normal mb-5 red-text" style={{ fontSize: '25px' }}>Wir helfen Ihnen gerne, die Energiebilanz Ihrer Immobilie zu verbessern!</h4>
            <Row className='justify-content-center mb-5'>
              <div className='d-flex pe-0'>
                <div className='d-flex flex-column justify-content-center'>
                  <div className='univers-normal light-grey-text mb-3 mt-3'>Mit der unterjährigen Verbrauchsinfo 10 % Einsparung erzielen*</div>
                  <div className='univers-normal'>Beim Energie sparen unterstützt die EED-Verbrauchsinfo von Techem! Sie enthält detaillierte
                    Angaben zum Verbrauch von Heizung und Warmwasser für Ihre Mieterinnen und Mieter.
                    Durch das Mehr an Transparenz kann der Verbrauch effizient sinken - und damit auch die Kosten.</div>
                  <a className='red-text' href='https://www.techem.com/de/de/immobilienservices/verbrauchsinformation?CID=referrer:organic:co2rechner_pdf:pfeil:co2rechner:verbrauchsinfo:co2:targeting:nr:2092022'
                    target='_blank' rel='noopener noreferrer'>Mehr erfahren
                    <img src={IconRight} alt='icon-right' className='ms-2'></img>
                  </a>
                </div>
                <img className='ms-3' src={ImageFinalTwo} alt='pdf-img' style={{ "width": "375px", "borderRadius": "40px 0px" }} />
              </div>
            </Row>
            <Row className='justify-content-center mb-5'>
              <div className='d-flex pe-0'>
                <div className='d-flex flex-column justify-content-center'>
                  <div className='univers-normal light-grey-text mb-3 mt-3'>CO<sub>2</sub>-Abgabe reduzieren mit unseren Energiespartipps</div>
                  <div className='univers-normal'>Was ist die optimale Raumtemperatur? Wie lüftet man richtig? Und warum sollte die Heizung nicht
                    komplett ausgestellt werden? Mit unseren sieben Tipps rund um das Thema „Clever heizen“ können
                    Ihre Mieterinnen und Mieter ihren Verbrauch noch stärker reduzieren!</div>
                  <a className='red-text' href='https://www.techem.com/de/de/news-und-wissen/alle-beitraege/clever-heizen-sieben-einfache-tipps-fuer-geldbeutel-gesundheit-und-umwelt?CID=referrer:organic:co2rechner_pdf:pfeil:co2rechner:heiztipps:co2:targeting:nr:2092022'
                    target='_blank' rel='noopener noreferrer'>Mehr erfahren
                    <img src={IconRight} alt='icon-right' className='ms-2'></img>
                  </a>
                </div>
                <img className='ms-3' src={ImageFinalThree} alt='pdf-img' style={{ "width": "375px", "borderRadius": "40px 0px" }} />
              </div>
            </Row>
            <Row className='justify-content-center mb-5'>
              <div className='d-flex d-flex pe-0'>
                <div className='d-flex flex-column justify-content-center'>
                  <div className='univers-normal light-grey-text mb-3 mt-3'>Mit dem Techem Heizungscheck Online Eindruck über Heizungsanlage erhalten</div>
                  <div className='univers-normal'>Nutzen Sie den kostenlosen Techem Heizungscheck Online und überprüfen Sie, wie fit Ihre Heizungsanlage ist.
                    Mit wenigen Fragen erfahren Sie mehr über mögliche Optimierungen, um Energie zu sparen.
                    Starten Sie den Check ganz einfach und bequem online.</div>
                  <a className='red-text'
                    href='https://www.techem.com/de/de/energieeffizienz/heizungscheck-online?CID=referrer:organic:co2rechner_pdf:link:co2rechner:heizungscheckrechner:co2:targeting:st:5122022'
                    target='_blank' rel='noopener noreferrer'>Mehr erfahren
                    <img src={IconRight} alt='icon-right' className='ms-2'></img>
                  </a>
                </div>
                <img className='ms-3' src={ImagePdfThreeOne} alt='pdf-img' style={{ "width": "375px", "borderRadius": "40px 0px" }} />
              </div>
            </Row>
            <Row className='univers-normal d-inline' style={{ 'color': 'gray' }}>
              *Mit der unterjährigen Verbrauchsinfo können Mieterinnen und Mieter laut Untersuchungen etwa 10 % ihres Heizungsverbrauchs senken (
              <a className='ps-0 pe-0'
                style={{ "width": "fit-content", 'color': 'red' }}
                href='https://www.dena.de/newsroom/meldungen/2017/dena-modellvorhaben-mehrheit-der-mieter-profitiert-von-informationen-zum-waermeverbrauch/'
                target='_blank' rel='noopener noreferrer'>dena-Studie
              </a>).
            </Row>
          </div>
          <div className='page-footer'>
            <Row className='position-relative mt-3 mb-5 techem-footer'>
              <div style={{ "backgroundColor": "red", "width": "100%", "height": "10px" }}></div>
              <img className='pdf-front-img' src={techemLogoShadow} alt='pdf-img' style={{ width: '220px' }}></img>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

export default FourthStep;